import React from 'react';

import StyledDivider, { Line, Txt } from './styles';

const Divider = ({ text = 'OR' }) => (
  <StyledDivider>
    <Line />
    <Txt>{text}</Txt>
    <Line />
  </StyledDivider>
);

export default Divider;
